import { useEffect, useRef, useState } from "react";
import {
    GetASD,
    GroupByForeignKey,
    GroupByPropCheck,
    GroupByProps,
} from "../Actions/GetContainer";
import { EjercicioByRange } from "./EjercicioByRange";
import { Mes } from "./Mes";
import FilterListIcon from "@mui/icons-material/FilterList";
import TuneIcon from "@mui/icons-material/Tune";
import { LoaderScreen } from "../../../components/LoaderScreen";
import Swal from "sweetalert2";
import { VisualizacionSelect } from "./VisualizacionSelect";
import { TipoSelect } from "./TipoSelect";

export const BoxFiltroScorecardVistaVendedor = ({
    children,
    onBoxChange,
    boxState,
    BoxClick,
    titulo_filtro,
    titulo = "",
    subtitulo = "",
    mostraradr = true,
    mostrarsucursal = true,
    mostrarvendedor = true,
    cargarfiltros = true
}) => {
    const [stateError, setError] = useState("");
    const [showVendedores, setShowVendedores] = useState(false);

    const fechaActual = new Date();
    const ejercicioActual = fechaActual.getFullYear();
    const mesActual = fechaActual.getMonth() + 1;
    // console.log(datoslocal)
    const [state, setState] = useState({
        data: [],
        adr: boxState.pv?.adr || [],
        sucursal: boxState.pv?.sucursal || [],
        vendedor: boxState.pv?.vendedor || [],
        ejercicioinicio: boxState.ejercicioinicio || ejercicioActual,
        periodoinicio: boxState.periodoinicio || "1",
        ejerciciofin: boxState.ejerciciofin || ejercicioActual,
        periodofin: boxState.periodofin || mesActual,
        tipo: boxState.tipo || "R",
        tabla: boxState.tabla || "L",

        visualizacion: boxState.visualizacion || "U"

    });
    //  console.log(boxState)
    const {
        data,
        adr,
        sucursal,
        vendedor,
        ejercicioinicio,
        periodoinicio,
        ejerciciofin,
        periodofin,
        tabla,
        tipo,
        visualizacion
    } = state;
    // console.log(boxState)
    const [loader, setLoader] = useState({
        mostrar: false,
        alerta: false,
        error: false,
        mensaje: "",
    });
    // console.log(state)
    useEffect(() => {
        onClose();
    }, []);


    useEffect(() => {
        var newadr = GroupByPropCheck(data, ["idEstado", "adr"]);
        var newsucursal = GroupByPropCheck(data, ["idSucursal", "descripcion"], false);

        // Verifica si hay alguna sucursal seleccionada antes de agrupar los vendedores
        var newvendedor = state.sucursal.some(suc => suc.checked)
            ? GroupByPropCheck(data, ["idempleado", "empleado", "idSucursal"], false)
            : [];

        setState({
            ...state,
            adr: newadr,
            sucursal: newsucursal,
            vendedor: newvendedor,
        });
    }, [data]);
    // console.log(data)
    const onChange = ({ target }) => {
        setState({
            ...state,
            [target.name]: target.value,
        });
        onBoxChange(target.name, target.value);
    };
    const labelclick = ({ target }) => {
        target.parentNode.firstChild.click();
    };

    useEffect(() => {
        const hasSucursalSelected = state.sucursal.some((sucursal) => sucursal.checked);
        setShowVendedores(hasSucursalSelected);

        // Limpia los vendedores si no hay sucursales seleccionadas
        if (!hasSucursalSelected) {
            setState({
                ...state,
                vendedor: [],
            });
        }
    }, [state.sucursal]);



    const selectedClick = ({ target }, index) => {
        let newarray, adrActive = [], sucursalactiva = [], newarrayvendedor = [];

        switch (target.name) {
            case "chk-adr":
                newarray = [...adr];
                newarray[index].checked = target.checked;

                newarray.forEach((item) => {
                    if (item.checked) {
                        adrActive.push({ idEstado: item.idEstado, adr: item.adr });
                        sucursalactiva = sucursalactiva.concat(
                            GroupByForeignKey(data, "idEstado", item.idEstado, ["idSucursal", "descripcion"])
                        );
                    }
                });

                if (sucursalactiva.length === 0) {
                    newarrayvendedor = [];
                }

                onBoxChange("pv", {
                    adr: adrActive,
                    sucursal: [],
                    vendedor: []
                });
                setState({
                    ...state,
                    adr: newarray,
                    sucursal: GroupByPropCheck(sucursalactiva.length === 0 ? data : sucursalactiva, ["idSucursal", "descripcion"], false),
                    vendedor: []
                });
                break;

            case "chk-sucursal":
                newarray = [...sucursal];
                newarray[index].checked = target.checked;

                newarray.forEach((item) => {
                    if (item.checked) {
                        sucursalactiva.push({ idSucursal: item.idSucursal, sucursal: item.descripcion });
                        newarrayvendedor = newarrayvendedor.concat(
                            GroupByForeignKey(data, "idSucursal", item.idSucursal, ["idempleado", "empleado", "idSucursal"])
                        );
                    }
                });


                if (sucursalactiva.length > 1) {
                    newarrayvendedor = [];
                }

                onBoxChange("pv", {
                    adr: boxState.pv.adr,
                    sucursal: sucursalactiva,
                    vendedor: []
                });
                setState({
                    ...state,
                    sucursal: newarray,
                    vendedor: newarrayvendedor
                });
                break;

            default:
                newarray = [...vendedor];
                newarray[index].checked = target.checked;

                let vendedoractivo = [];
                newarray.forEach((item) => {
                    if (item.checked) {
                        vendedoractivo.push({
                            idvendedor: item.idempleado,
                            vendedor: item.empleado,
                            // idsucursal: item.idSucursal
                        });
                    }
                });

                onBoxChange("pv", {
                    adr: boxState.pv.adr,
                    sucursal: boxState.pv.sucursal,
                    vendedor: vendedoractivo
                });
                setState({
                    ...state,
                    vendedor: newarray
                });
                break;
        }
    };


    const onClick = () => {
        const element = document.getElementById("box-structure-bussiness-filtros");
        if (element != undefined && element != null) {
            element.style.display = "flex";
        }
    };
    const onClose = () => {
        const element = document.getElementById("box-structure-bussiness-filtros");
        if (element != undefined && element != null) {
            element.style.display = "none";
        }
        closeConsulta();
    };
    const closeConsulta = () => { };
    const consultar = () => {
        // setLoader({ ...loader, mostrar: true });
        onClose();
        BoxClick()

            .then(() => {

                setLoader({ ...loader, mostrar: false });
                setState({
                    ...state,
                });
            })
            .catch((err) => {
                setLoader({ ...loader, mostrar: false });
                Swal.fire("SCORECARD GENERAL", JSON.stringify(err), "error");
            });
    };
    const GetChildren = (key) => {
        if (children === undefined || children === null) return <></>;
        if (Array.isArray(children)) {
            var result = children.filter((x) => x.key === key);
            if (result !== undefined && result !== null && result.length > 0) {
                return result[0];
            }
        }
        if (children.key === key) return children;

        return <></>;
    };

    const capitalizeWords = (text) => {
        if (!text) return '';
        return text
            .toLowerCase()
            .split(' ')
            .map(word => word.charAt(0).toUpperCase() + word.slice(1))
            .join(' ');
    };
    return (
        <>
            <LoaderScreen loader={loader} />
            <div className="scorecard-gerente-filtro">
                <div className="encabezado-reports-filtros">
                    <div>
                        <div className="filtro-titulo">
                            <button className="boton-box-structure" onClick={onClick}>
                                <TuneIcon />
                                Filtro
                            </button>
                        </div>
                        {GetChildren("box-actions")}
                    </div>
                    <div
                        id="box-structure-bussiness-filtros"
                        key="box-structure-bussiness-filtros"
                    >
                        <div className="filtro-soy-el-titulo">
                            <div className="filtro-soy-el-titulo-header">
                                {titulo_filtro}
                                <span className="filtro-soy-span-close" onClick={onClose}>
                                    X
                                </span>
                            </div>
                            <div className="filtro-soy-el-titulo-line">
                                <div className="filtro-soy-el-titulo-line-bl"></div>
                                <div className="filtro-soy-el-titulo-line-circle"></div>
                                <div className="filtro-soy-el-titulo-line-br"></div>
                            </div>
                        </div>
                        <div className="box-action-container-filtros">
                            <div className="filtro-tiempo-tipo">
                                <div className="filtro-group">
                                    <label>Visualizar</label>
                                    <TipoSelect name="tipo" value={tipo} onChange={onChange} />
                                </div>
                                <div className="filtro-group">
                                    <label>Ejercicio {state.tipo === "D" ? "" : "Inicio"}</label>
                                    <EjercicioByRange
                                        name="ejercicioinicio"
                                        value={ejercicioinicio}
                                        onChange={onChange}
                                    />
                                </div>
                                {state.tipo === "D" ? (
                                    <div></div>
                                ) : (
                                    <>
                                        <div className="filtro-group">
                                            <label>Periodo Inicio</label>
                                            <Mes
                                                name="periodoinicio"
                                                value={periodoinicio}
                                                onChange={onChange}
                                            />
                                        </div>
                                        <div className="filtro-group">
                                            <label>Ejercicio Fin</label>
                                            <EjercicioByRange
                                                name="ejerciciofin"
                                                value={ejerciciofin}
                                                onChange={onChange}
                                            />
                                        </div>
                                        <div className="filtro-group">
                                            <label>Periodo Fin</label>
                                            <Mes name="periodofin" value={periodofin} onChange={onChange} />
                                        </div>
                                    </>
                                )}
                                {/* <div className="filtro-group">
                                    <label>Tabla</label>
                                    <TablaSelect name="tabla" value={tabla} onChange={onChange} />
                                </div> */}
                                <div className="filtro-group">
                                    <label>Ver por</label>
                                    <VisualizacionSelect name="visualizacion" value={visualizacion} onChange={onChange} />
                                </div>
                                {GetChildren("box-filtro")}

                                <div className="box-filtros-container-buttons">
                                    {/* <button className="button-cancel" onClick={onClose}>
                                        Cancelar
                                    </button> */}
                                    <button className="button-accept" onClick={consultar}>
                                        <FilterListIcon /> Cargar
                                    </button>
                                </div>
                            </div>

                            <div className="filtro-adr">  </div>

                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};
